export default __webpack_public_path__ + "static/media/shared-budget-reductions.7d06854a.png";